<script lang="ts">
    import { _ } from "svelte-i18n";
    import Visual from "./Visual.svelte";
    import EditExplainer from "./EditExplainer.svelte";
    import AnalyseExplainer from "./AnalyseExplainer.svelte";
    import DataExplainer from "./DataExplainer.svelte";
    import ShareExplainer from "./ShareExplainer.svelte";
</script>

<div class="d-none d-lg-block">
    <div
        style="width: 1024px; height: 401px; position: relative;"
        class="text-white"
    >
        <div class="edit">
            <EditExplainer title={false} />
        </div>
        <div class="analyse">
            <AnalyseExplainer title={false} />
        </div>
        <div class="data">
            <DataExplainer title={false} />
        </div>
        <div class="share">
            <ShareExplainer title={false} />
        </div>
        <div class="visual">
            <Visual />
        </div>
    </div>
</div>
<div class="d-lg-none col-12 col-md-6 my-auto">
    <Visual />
</div>
<div class="d-lg-none col-12 col-md-6 text-white">
    <div class="row mt-6 mt-md-3">

        <EditExplainer />
    </div>
    <div class="row mt-3">

        <AnalyseExplainer />
    </div>
    <div class="row mt-3">

        <DataExplainer />
    </div>
    <div class="row mt-3">

        <ShareExplainer />
    </div>
</div>

<style>
    .visual {
        position: absolute;
        top: 0;
        left: 350px;
    }
    .edit {
        position: absolute;
        top: 0;
        left: 0;
        width: 300px;
    }
    .analyse {
        position: absolute;
        top: 158px;
        left: 0;
        width: 300px;
    }
    .data {
        position: absolute;
        top: 310px;
        left: 0;
        width: 300px;
    }
    .share {
        position: absolute;
        top: 158px;
        right: 0;
        width: 300px;
    }
</style>
